import { Icon, Tooltip, TooltipContent, TooltipTrigger } from "@/shared/components";
import { cn } from "@/shared/utils";

type InzetVoorwaardenProps = {
    className?: string;
};

export function InzetVoorwaarden({ className }: InzetVoorwaardenProps) {
    return (
        <Tooltip>
            <TooltipTrigger
                data-testid="vos-voorwaarden"
                className={cn("text-content-interactive-default text-s flex items-center gap-1.5 self-start font-bold", className)}
            >
                <Icon name="info" size="xs" /> Voorwaarden inzet VOS
            </TooltipTrigger>
            <TooltipContent className="max-w-fit">
                <span className="font-bold">VOS Inzetcriteria</span>
                <p>Prognose minimaal X + 60 minuten</p>
                <p>Verstoring tussen 06:30 en 21:30 uur</p>
                <p>Geen V&S inzet op station</p>
                <p>VSM 01 + 02 actief</p>
                <p>Bij exceptionele situatie, eerst akkoord van CW</p>
            </TooltipContent>
        </Tooltip>
    );
}
